export const OPEN_TRIAL_SCHEDULER_EVENT = 'sflcm:open-trial-scheduler';

// The modal normally handles this synchronously. If its lazy chunk has not
// mounted yet, preserve a usable escape hatch by opening Opus1 directly.
export function requestTrialSchedulerOpen(detail) {
  if (typeof window === 'undefined') return false;

  const event = new CustomEvent(OPEN_TRIAL_SCHEDULER_EVENT, {
    cancelable: true,
    detail,
  });
  const handled = !window.dispatchEvent(event);

  if (!handled) {
    window.open(detail.url, '_blank', 'noopener,noreferrer');
  }

  return handled;
}
